<template>
	<CList :pConfigList="ConfigList" :segurity="segurity">
		<template slot="bodyForm">
			<CLoader :pConfigLoad="ConfigLoad">
				<template slot="BodyFormLoad">
					<div class="container-fluid">
						<form id="FormNotaVenta" role="form" method="post" autocomplete="off" onSubmit="return false">
							<input type="hidden" :value="calcula">
							
							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
									<label class="form-label" for="Cliente">Cliente</label>
									<input type="text" v-model="objNotaVenta.Cliente" class="form-control" id="Cliente" placeholder="Ingresar Cliente" readonly />
									<CValidation v-if="this.errorvalidacion.Cliente" :Mensaje="'*'+errorvalidacion.Cliente[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
									<label class="form-label" for="Rfc">Cotización</label>
									<input type="text" v-model="objAgenos.FolioCotizacion" class="form-control" id="Rfc" placeholder="Ingresar Rfc" readonly />
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
									<label class="form-label" for="Folio">Folio</label>
									<input type="text" v-model="objNotaVenta.Folio" class="form-control" id="Folio" placeholder="Ingresar Folio" readonly />
									<CValidation v-if="this.errorvalidacion.Folio" :Mensaje="'*'+errorvalidacion.Folio[0]"/>
								</div>
							</div>

							
							<div class="form-group row mb-5">
								<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
									<label class="form-label" for="Domicilio">Domicilio</label><br>
									<!-- <textarea v-model="objNotaVenta.Domicilio" class="form-control" id="Domicilio" placeholder="Ingresar Domicilio" rows="3" readonly></textarea> -->
									<span>Calle: <b>{{objCliente.Calle}}</b>, N° Ext. <b>{{objCliente.NumExt}}</b>, Colonia: <b>{{objCliente.Colonia}}</b>, Código Postal: <b>{{objCliente.CP}}</b></span><br>
									<span>Pais: <b>{{objCliente.Pais}}</b>, Estado: <b>{{objCliente.Estado}}</b>, Municipio: <b>{{objCliente.Ciudad}}</b></span>
								</div>

								<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
									<label class="form-label" for="Rfc">Rfc</label>
									<input type="text" v-model="objNotaVenta.Rfc" class="form-control" id="Rfc" placeholder="Ingresar Rfc" readonly />
									<CValidation v-if="this.errorvalidacion.Rfc" :Mensaje="'*'+errorvalidacion.Rfc[0]"/>
								</div>

								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<label class="form-label" for="FormaPago">Forma de Pago</label>
									<input type="text" v-model="objNotaVenta.FormaPago" class="form-control" id="FormaPago" placeholder="Ingresar FormaPago" />
									<CValidation v-if="this.errorvalidacion.FormaPago" :Mensaje="'*'+errorvalidacion.FormaPago[0]"/>
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-8 col-lg-2 col-xl-2">
									<h5>Conceptos</h5>
								</div>

								<div class="col-12 col-sm-12 col-md-8 col-lg-3 col-xl-3">
									<div class="form-check form-check-inline" v-show="objNotaVenta.IdNotaVenta==0">
										<input type="radio" v-model="objNotaVenta.TipoNotaMoneda" @change="GetConceptosCotizacion()" class="form-check-input" name="rbtipo[]" value="MXN" id="CheckMoneda1">
										<label class="form-check-label" for="CheckMoneda1">
											MXN
										</label>
									</div>

									<div class="form-check form-check-inline" v-show="objNotaVenta.IdNotaVenta==0">
										<input type="radio" v-model="objNotaVenta.TipoNotaMoneda" @change="GetConceptosCotizacion()" class="form-check-input" name="rbtipo[]" value="USD" id="CheckMoneda2">
										<label class="form-check-label" for="CheckMoneda2">
											USD
										</label>
									</div>

									<div class="form-check form-check-inline" v-show="objNotaVenta.IdNotaVenta==0">
										<input type="radio" v-model="objNotaVenta.TipoNotaMoneda" @change="GetConceptosCotizacion()" class="form-check-input" name="rbtipo[]" value="" id="CheckMoneda3">
										<label class="form-check-label" for="CheckMoneda3">
											Todos
										</label>
									</div>
								</div>

								<div class="col-12 col-sm-12 col-md-8 col-lg-3 col-xl-3" v-show="(objNotaVenta.TipoNotaMoneda !='MXN')">
									<div class="row">
										<label class="col-form-label col-12 col-sm-12 col-md-8 col-lg-5 col-xl-5">
											Tipo Cambio
										</label>
										<div class="col-12 col-sm-12 col-md-8 col-lg-5 col-xl-5">
											<input type="text" v-model="objNotaVenta.CambioUsd" @input="$number_decimal($event,objNotaVenta,'CambioUsd');CalculaTipoCambioUsd()" class="form-control form-control-sm">
										</div>
									</div>
								</div>

								<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-end">
								</div>
							</div>

							<div class="row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
								<CLoader :pConfigLoad="ConfigLoadTable">
								<template slot="BodyFormLoad">
									<div class="table-responsive pb-0">
										<table class="table table-striped mb-0">
											<thead>
												<tr>
													<th width="3%">#</th>
													<th width="5%">Cantidad</th>
													<th width="29%">Descripción</th>
													<th width="9%">Precio U.</th>
													<th width="4%">Descuento</th>
													<th width="13%">Importe</th>
													<th width="3%">*</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(item,index) in ListaConceptosNota" :key="index">
													<td>{{(index+1)}}</td>
													<td>
														<input type="text" v-model="item.Cantidad" @input="$onlyNums($event,item,'Cantidad');EjecutarCalculos();" class="form-control form-control-sm" :readonly="(item.IdDetalleCotizacion>0)?true:false">
													</td>
													<td>
														<textarea v-model="item.Descripcion" class="form-control" rows="3"></textarea>
													</td>
													<td>
														<input type="text" v-model="item.Precio" @input="$number_decimal($event,item,'Precio');EjecutarCalculos();" class="form-control form-control-sm" :readonly="(item.IdDetalleCotizacion>0)?true:false">
													</td>
													<td>
														<input type="text" v-model="item.Descuento" @input="$number_decimal($event,item,'Descuento');EjecutarCalculos()" class="form-control form-control-sm">
													</td>
													<td>
														<input type="text" v-model="item.Importe" class="form-control form-control-sm" readonly>
													</td>
													<td>
														<button type="button" @click="BorrarItemConcepto(index)" class="btn btn-danger btnpequenio">
															<i class="fa fa-trash"></i>
														</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
									<CValidation v-if="this.errorvalidacion.ArregloEventos" :Mensaje="'*'+errorvalidacion.ArregloEventos[0]"/>
								</template>
								</CLoader>
								</div>
							</div>
							
								
							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 mb-2">
									<label class="form-label" for="Observaciones">Observaciones</label>
									<textarea v-model="objNotaVenta.Observaciones" class="form-control" id="Observaciones" placeholder="Ingresar Observaciones" rows="3"></textarea>
									<CValidation v-if="this.errorvalidacion.Observaciones" :Mensaje="'*'+errorvalidacion.Observaciones[0]"/>
								</div>

								<div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-4">
									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="Descuento">Descuento:</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objNotaVenta.Descuento" class="form-control form-control-sm" id="Descuento" readonly>
										</div>
									</div>

									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="SubTotal">SubTotal:</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objNotaVenta.SubTotal" class="form-control form-control-sm" id="SubTotal" readonly>
										</div>
									</div>

									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="ImporteT">Importe:</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objAgenos.Importe" class="form-control form-control-sm" id="ImporteT" readonly>
										</div>
									</div>

									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6">
											<div class="row">
												<div class="col-4 col-sm-6 col-md-3 col-lg-4 col-xl-4"></div>
												<div class="col-4 col-sm-6 col-md-3 col-lg-4 col-xl-4">
													<div class="form-check">
														<input class="form-check-input" type="checkbox" v-model="objAgenos.chkQuitaIva" @change="EjecutarCalculos()" value="" id="flexCheckDefaultiv">
														<label class="form-check-label" for="flexCheckDefaultiv">
															Quitar
														</label>
													</div>
												</div>

												<div class="col-4 col-sm-6 col-md-6 col-lg-4 col-xl-4 text-end">
													<label for="Iva">I.V.A {{objAgenos.TrasladoIva}}%:</label>
												</div>
											</div>
										</div>

										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objNotaVenta.Iva" class="form-control form-control-sm" id="Iva" readonly>
										</div>
									</div>

									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="Total">Total:</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objNotaVenta.Total" class="form-control form-control-sm" id="Total" readonly>
										</div>
									</div>
								</div>
							</div>
							
													
							<br>
							<CBtnSave :poBtnSave="oBtnSave" />
						</form>
					</div>
				</template>
			</CLoader>
		</template>
	</CList>
	
</template>
<script>

const EmitEjecuta = 'seccionNotaVenta';

export default {
    name: 'FormNotaVenta',
    props: ['Id','Obj'],
    components:{
    },
    data() {
        return {
			ConfigList:{
                Title: 'Formulario Nota de Venta',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
				ShowTitleFirst: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'notaventa',
                EmitSeccion: EmitEjecuta,
            },
			ConfigLoadTable:{
                ShowLoader: false,
                ClassLoad: false,
            },
            objNotaVenta: {
				IdNotaVenta: 0,
				IdCotizacion: 0,
				IdEmpresa: 0,
				IdCliente: 0,
				IdUsuario: 0,
				FechaRegistro: '',
				Fecha: '',
				Folio: '',
				Cliente: '',
				Rfc: '',
				Domicilio: '',
				FormaPago: '',
				SubTotal: '',
				PorcentajeIva: '',
				Iva: '',
				Descuento: '',
				Total: '',
				Observaciones: '',
				MostrarPaquete: '',
				TipoNotaMoneda: '',
				CambioUsd: '',
				IdSucursal: 0,
            },
			objAgenos: {
				Guardar: 1,
				FolioCotizacion: '',
				Importe: '',
				TrasladoIva: 16,
				ValorIva: 0,
				chkQuitaIva: false,
			},
			objCliente: {},
            segurity: {},
			//masks: { input: 'YYYY-MM-DD' }, // quitar sino lleva fecha 
            errorvalidacion: [],
			Emit: EmitEjecuta,
			ListaConceptosNota: [],
			ObjCotizacion: {},
        }
    },
    methods :
    {
       	async Guardar()
        {
			let Domicilio = '{'	
			+'"Calle": "'+this.objCliente.Calle+'",'
			+'"NumExt": "'+this.objCliente.NumExt+'",'
			+'"Colonia": "'+this.objCliente.Colonia+'",'
			+'"CP": "'+this.objCliente.CP+'",'
			+'"Pais": "'+this.objCliente.Pais+'",'
			+'"Estado": "'+this.objCliente.Estado+'",'
			+'"Ciudad": "'+this.objCliente.Ciudad+'"'
			+"}";

			//Domicilio = JSON.parse(Domicilio); PARA LEERLO

			let formData = new FormData();
			formData.set('IdNotaVenta', this.objNotaVenta.IdNotaVenta);
			formData.set('IdCotizacion', this.objNotaVenta.IdCotizacion);
			formData.set('IdEmpresa', this.objNotaVenta.IdEmpresa);
			formData.set('IdSucursal', this.objNotaVenta.IdSucursal);
			formData.set('IdCliente', this.objNotaVenta.IdCliente);
			formData.set('IdUsuario', this.objNotaVenta.IdUsuario);

			formData.set('Cliente', this.objNotaVenta.Cliente);
			formData.set('Rfc', this.objNotaVenta.Rfc);
			formData.set('Domicilio', Domicilio);
			formData.set('FormaPago', this.objNotaVenta.FormaPago);

			let Descuento = this.objNotaVenta.Descuento;
			let SubTotal = this.objNotaVenta.SubTotal;
			let Iva = this.objNotaVenta.Iva;
			let PorcentajeIva = this.objNotaVenta.PorcentajeIva;
			let Total = this.objNotaVenta.Total;
			let CambioUsd = this.objNotaVenta.CambioUsd;

			Descuento = (Descuento == '') ? 0 : Descuento;
			SubTotal = (SubTotal == '') ? 0 : SubTotal;
			Iva = (Iva == '') ? 0 : Iva;
			PorcentajeIva = (PorcentajeIva == '') ? 0: PorcentajeIva;
			Total = (Total == '') ? 0 : Total;
			CambioUsd = (CambioUsd == '') ? 0 : CambioUsd;

			formData.set('SubTotal', SubTotal);
			formData.set('Descuento', Descuento);
			formData.set('Iva', Iva);
			formData.set('PorcentajeIva', PorcentajeIva);
			formData.set('Total', Total);
			formData.set('Observaciones', this.objNotaVenta.Observaciones);
			formData.set('MostrarPaquete', this.objNotaVenta.MostrarPaquete);
			formData.set('TipoNotaMoneda', this.objNotaVenta.TipoNotaMoneda);
			formData.set('CambioUsd', CambioUsd);
			formData.set('Detalle', JSON.stringify(this.ListaConceptosNota));
			
			this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;
			
			await this.$http.post('notaVentas', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err)
        {
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "notaVentas/"+this.objNotaVenta.IdNotaVenta
            ).then((res) => {
                this.objNotaVenta = res.data.data;
				let response = res.data.detalle;

				this.ListaConceptosNota = response;
				if(this.objNotaVenta.PorcentajeIva == 0){
					this.objAgenos.chkQuitaIva = true;
				}

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objNotaVenta = {
				IdNotaVenta: 0,
				IdCotizacion: 0,
				IdEmpresa: 0,
				IdCliente: 0,
				IdUsuario: 0,
				FechaRegistro: '',
				Fecha: '',
				Folio: '',
				Cliente: '',
				Rfc: '',
				Domicilio: '',
				FormaPago: '',
				SubTotal: '',
				PorcentajeIva: '',
				Iva: '',
				Descuento: '',
				Total: '',
				Observaciones: '',
				MostrarPaquete: '',
				TipoNotaMoneda: '',
				CambioUsd: '',
				IdSucursal: 0,
				
            }
            this.errorvalidacion = [];
        },
		Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute,params:{pLugar: this.RutaDeOrigen}});
            // this.$router.push({name:'routeraregresar',params:{obj:this.obj}});
        },
		SetearDataCliente()
		{
			if(this.objNotaVenta.IdNotaVenta == 0)
			{
				this.objNotaVenta.IdCotizacion = this.ObjCotizacion.IdCotizacion;
				this.objNotaVenta.IdCliente = this.ObjCotizacion.IdAgente;
				this.objNotaVenta.Cliente = this.ObjCotizacion.Agente.RazonSocial;
				this.objNotaVenta.Rfc = this.ObjCotizacion.Agente.RFC;

				this.objCliente.Calle = this.ObjCotizacion.Agente.Calle;
				this.objCliente.Colonia = this.ObjCotizacion.Agente.Colonia;
				this.objCliente.Ciudad = this.ObjCotizacion.Agente.Municipio;
				this.objCliente.Pais = this.ObjCotizacion.Agente.Pais;
				this.objCliente.Estado = this.ObjCotizacion.Agente.Estado;
				this.objCliente.Municipio = this.ObjCotizacion.Agente.Municipio;
				this.objCliente.CP = this.ObjCotizacion.Agente.CP;
				this.objCliente.NumExt = this.ObjCotizacion.Agente.NumExt;
				this.objCliente.NumInt = this.ObjCotizacion.Agente.NumInt;

				this.GetConceptosCotizacion();
			}
			
			this.objAgenos.FolioCotizacion = this.ObjCotizacion.Folio;
		},
		GetConceptosCotizacion()
		{
			this.ConfigLoadTable.ShowLoader = true;
			this.$http.get("getConceptosCotzNota",{
				params:{
					TipoMoneda: this.objNotaVenta.TipoNotaMoneda,
                    IdCotizacion: this.ObjCotizacion.IdCotizacion,
                }
			}).then((res) => {
				//console.log(res.data.data);
				let ArregloConceptos = [];

				res.data.data.map(function(element){
					let obj = {
						IdNotaVenta: 0,
						IdDetalleNota: 0,
						IdCotizacion: element.IdCotizacion,
						IdDetalleCotizacion: element.IdDetalleCotizacion,
						Cantidad: element.Cantidad,
						Descripcion: element.Descripcion,
						Precio: element.Precio,
						Descuento: 0,
						Importe: '',

						PrecioDefault: element.Precio,
						TipoMoneda: element.TipoMoneda,
					};

					ArregloConceptos.push(obj)
				});

				//console.log(ArregloConceptos);
				this.ListaConceptosNota = ArregloConceptos;
				
			}).finally(()=>{
                this.ConfigLoadTable.ShowLoader = false;
				this.EjecutarCalculos();
            });
		},
		BorrarItemConcepto(index)
		{
			this.ListaConceptosNota.splice(index, 1);
			this.EjecutarCalculos();
		},
		EjecutarCalculos()
        {
			let SubTotal = 0;
			let ImporteTotal = 0;
            let Iva = 0.16//this.objAgenos.ValorIva;
            //let RetencionP = this.objAgenos.ValorRetencion;
            let Total = 0;
			//let TotalRetencion = 0;
			let TotalDescuento = 0;
            let Arreglo = this.ListaConceptosNota;
			let chkQuitaIva = this.objAgenos.chkQuitaIva;
           

            for(let i=0; i<Arreglo.length; i++)
            {
				//let ValorRetencion = 0;
				let ValorDescuento = 0;

				/* if(Arreglo[i].RetencionIva){
					ValorRetencion = RetencionP;
				} */
				if(Arreglo[i].Descuento>0){
					ValorDescuento = parseFloat(Arreglo[i].Descuento);
				}

                let Cantidad = Arreglo[i].Cantidad;
                let PrecioUn = Arreglo[i].Precio;

				Cantidad = (Cantidad!='') ? Cantidad : 0;
				PrecioUn = (PrecioUn!='') ? PrecioUn : 0;

                Cantidad = (isNaN(Cantidad)) ? 0 : parseFloat(Cantidad);
                PrecioUn = (isNaN(PrecioUn)) ? 0 : parseFloat(PrecioUn);

				let Importe = parseFloat(Cantidad*PrecioUn);
				Importe = (isNaN(Importe)) ? 0 : parseFloat(Importe);
				Arreglo[i].Importe = Importe.toFixed(2);

				// SUMA DE TODOS LOS IMPORTES DA EL SUBTOTAL
                SubTotal+= Importe;

				// SE SUMAN TODOS LOS DESCUENTOS
				TotalDescuento+= ValorDescuento;

				// CALCULAMOS LA RETENCION POR PARTIDA
				// IMPORTE - DESCUENTOS INDIVIDUALES * PORCENTAJE DE LA RETENCION
				/* let IvaRetencion = parseFloat(Importe-ValorDescuento)*parseFloat(ValorRetencion);
				IvaRetencion = (isNaN(IvaRetencion)) ? 0 : IvaRetencion;
				TotalRetencion+= IvaRetencion;
				
				if(Arreglo[i].TasaRetIva != undefined){
					Arreglo[i].TasaRetIva = ValorRetencion;
					Arreglo[i].ImporteRetIva = IvaRetencion;
				} */
            }

			// EL SUBTOTAL ES LA SUMA DE TODOS LOS IMPORTES
            TotalDescuento = (isNaN(TotalDescuento)) ? 0 : TotalDescuento;
            SubTotal = (isNaN(SubTotal)) ? 0 : SubTotal;

			// EL IMPORTE ES EL SUBTOTAL MENOS LOS DESCUENTOS
			ImporteTotal = parseFloat(SubTotal)-parseFloat(TotalDescuento);
			ImporteTotal = (isNaN(ImporteTotal)) ? 0 : ImporteTotal;

			if(chkQuitaIva){
				Iva = 0;
			}
			this.objNotaVenta.PorcentajeIva = Iva;

			// EL IVA ES EL IMPORTE POR EL PORCENTAJE DE IVA
            Iva = parseFloat(ImporteTotal)*parseFloat(Iva);
            Iva = (isNaN(Iva)) ? 0 : Iva;
            Total = parseFloat(ImporteTotal)+parseFloat(Iva)//-parseFloat(TotalRetencion);

			//this.objEvento.Iva 			= 16;
            this.objNotaVenta.Descuento	= parseFloat(TotalDescuento).toFixed(2);
            this.objNotaVenta.SubTotal	= parseFloat(SubTotal).toFixed(2);
			this.objAgenos.Importe		= parseFloat(ImporteTotal).toFixed(2);
            this.objNotaVenta.Iva 		= parseFloat(Iva).toFixed(2);
            this.objNotaVenta.Total		= parseFloat(Total).toFixed(2);
            //this.objFactura.RetencionIva= parseFloat(TotalRetencion).toFixed(2);
        },
		CalculaTipoCambioUsd()
		{
			let CambioUsd	= this.objNotaVenta.CambioUsd; // tipo de cambio
			let PrecioArr	= this.ListaConceptosNota;

			if(CambioUsd == ''){
				CambioUsd = 0;
			}

			if(CambioUsd>=0)
			{
				for(let i=0; i<PrecioArr.length; i++)
				{
					let Resultado = PrecioArr[i].PrecioDefault;
					let TipoMoneda = PrecioArr[i].TipoMoneda;

					if(TipoMoneda == 'USD' && CambioUsd>0)
					{
						let Importe = PrecioArr[i].PrecioDefault;
						Resultado = parseFloat(Importe)*parseFloat(CambioUsd)
					}

					Resultado = (isNaN(Resultado))? 0 : Resultado;
					PrecioArr[i].Precio = Resultado;
				}
			}
			else
			{
				for(let i=0; i<PrecioArr.length; i++)
				{
					let Importe = PrecioArr[i].PrecioDefault;

					Importe = (isNaN(Importe)) ? 0 : Importe;
					PrecioArr[i].Precio = Importe;
				}
			}

			this.EjecutarCalculos();
		}
    },
	created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();

		if(this.Id!=''){
            this.objNotaVenta.IdNotaVenta = this.Id;
		}

		console.log(this.Obj);
		if(this.Obj!=undefined){
			this.RutaDeOrigen = this.Obj.Lugar;
			this.ObjCotizacion = this.Obj.objCotz;
			this.SetearDataCliente();
		}

        if(this.objNotaVenta.IdNotaVenta>0) 
        {
            this.objNotaVenta.IdNotaVenta = this.Id;
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
	computed:{
		calcula(){
			if(this.objNotaVenta.TipoNotaMoneda=='MXN'){
				this.objNotaVenta.CambioUsd = 0;
			}
			else{
				this.CalculaTipoCambioUsd();
			}

			this.EjecutarCalculos();
			return this.objNotaVenta.TipoNotaMoneda;
		}
	}
}
</script>
